import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseMiniIcon, SettingsMenuVerticalIcon, ViewIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
const styledItemCss = "shmtwb1";
const StyledItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(styledItemCss, props.className)} />);
const actionsCss = "a1mtv7nn";
const Actions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionsCss, props.className)} />;
});
export const ActionsDropdown = ({
  request,
  onShow,
  onCancel
}) => {
  const [toggle, Dropdown, isExpanded] = useDropdown();
  return <Actions>
      <IconButton size="small" aria-expanded={isExpanded} title={I18n.t('publisher.action.options')} onClick={toggle}>
        <SettingsMenuVerticalIcon />
      </IconButton>
      <Dropdown>
        <ViewportDropdownMenu>
          <StyledItem onClick={onShow}>
            <ViewIcon />
            {I18n.t('publisher.organization_settings.data_deletion.section.deletion_requests.details')}
          </StyledItem>
          {request.state === 'pending' && <StyledItem onClick={onCancel}>
              <CloseMiniIcon />
              {I18n.t('publisher.action.cancel')}
            </StyledItem>}
        </ViewportDropdownMenu>
      </Dropdown>
    </Actions>;
};

require("./actions_dropdown.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./actions_dropdown.js");